import React from "react";

const GradientBackground = ({
  showNextEpisodeCard,
  isSideNavOpen,
  showStillWatchingPrompt,
  showBgImage,
  videoControlsStyle,
}) => {
  const style =
    (showNextEpisodeCard && !isSideNavOpen) || showStillWatchingPrompt
      ? { opacity: 0.9, visibility: "visible" }
      : !showBgImage
      ? videoControlsStyle
      : null;

  return <div className="gradient-bg" style={style}></div>;
};

export default GradientBackground;
